import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M160 620L458 298C471 284 485 278 500 278C515 278 528 283 542 298L836 616C877 660 863 706 812 706H188C140 706 122 664 160 620Z" })
});
export default SvgCaretUp;
